<template>
  <div class="container">
    <h4>Tutorials</h4>
    <div class="row mt-4">
      <div v-for="url in urls" :key="url.url" class="col-12 col-lg-6">
        <h5>
          <strong>{{ url.title }}</strong>
        </h5>
        <iframe
          width="560"
          height="315"
          v-bind:src="url.url"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: [
        {
          title: "Archiving Data",
          url: "https://www.youtube.com/embed/tqKcaNYYGAA"
        },
        {
          title: "Starting on a new Term after Archiving Data",
          url: "https://www.youtube.com/embed/wtBlbJVwGTE"
        },
        {
          title: "Signing Up and Signing In for the First Time",
          url: "https://www.youtube.com/embed/9mLP5BUov8E"
        },
        {
          title: "Adding Subjects",
          url: "https://www.youtube.com/embed/gejhc_VpOEc"
        },
        {
          title: "Adding Students",
          url: "https://www.youtube.com/embed/_jXOKaxsP6E"
        },
        {
          title: "Adding Units and Keeping Student Data",
          url: "https://www.youtube.com/embed/TEbA6FZUams"
        },
        {
          title: "Utilizing Subjects and Units",
          url: "https://www.youtube.com/embed/Dz7WB2hnqyc"
        },
        {
          title: "Creating Behavior Trackers",
          url: "https://www.youtube.com/embed/yb6lgIYYmIo"
        },
        {
          title: "Viewing Student Data",
          url: "https://www.youtube.com/embed/M9cJBjhsqSw"
        },
        {
          title: "Managing Student Permissions",
          url: "https://www.youtube.com/embed/hV_Nuvvpohg"
        }
      ]
    };
  }
};
</script>
